import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';

/**
 * AjaxAction - добавляет ajax postJson поведение на контрол с аттрибутом ajax-action
 * если указан атррибут ajax-action-form то на все input[type=text] навешивается keydown, кроме элементов исключений, указанных в массиве excludeTags
 * если контрол начинается с input- но не submit то вызов ajax метода будет осуществляться по изменению, в противном случае по клик
 * Зависит от EnterBehaviour
 * ajax-action-use-spinner - показывать или нет спиннер
 * ajax-action-success-action - действие на успех
 */
export class AjaxActionBehavior extends BaseEmptyPrefixControlBehaviour {
    ajaxActionTypes: any = {
        default: {
            all: {},
            'input-checkbox': {
                delay: 300,
            },
        },
    };
    private excludeTags: string[];

    constructor() {
        super('ajax-action');
        this.excludeTags = [new Behaviours.EnterBehaviour().getInstalledTag()];
    }

    protected installBehaviour(element: HTMLElement): void {
        const isAjsxForm = $(element).attr(this.tag + '-form');
        if (isAjsxForm) {
            const form = $(element).parents('form')[0];
            const selector = 'input[type=text]';
            let excludeSelector = '';
            if (this.excludeTags && this.excludeTags.length > 0) {
                excludeSelector += ':not(';
                for (let i = 0; i < this.excludeTags.length; i++) {
                    excludeSelector += '[' + this.excludeTags[i] + ']';
                    if (i < this.excludeTags.length - 1) excludeSelector += ',';
                }
                excludeSelector += ')';
            }
            $(form).on(
                'keydown',
                selector + excludeSelector,
                { ajaxActionElement: element },
                (e) => this.ajaxActionEnterHandler(e)
            );
        }

        const elementFullType = Utils.getElementFullType(element);
        if (
            elementFullType.startsWith('input-') &&
            elementFullType != 'input-submit'
        ) {
            $(element).change((e) => this.ajaxActionSubmitHandler(e));
        } else {
            $(element).click((e) => this.ajaxActionSubmitHandler(e));
        }

        $(element).on('ajax-action', (e) => this.ajaxActionSubmitHandler(e));

        $(element).removeAttr('href');
    }

    private ajaxActionSubmitHandler(evt) {
        evt.preventDefault();

        return this.ajaxActionSubmit(evt.currentTarget);
    }

    private ajaxActionSubmit(element) {
        const url = $(element).attr(this.tag);

        let data;
        const elementFullType = Utils.getElementFullType(element);
        if (elementFullType == 'input-checkbox') {
            data = {};
            data[$(element).attr('name')] = $(element).is(':checked');
        } else if (elementFullType.startsWith('input-')) {
            data = {};
            data[$(element).attr('name')] = $(element).val();
        } else {
            const val = $(element).data('value');
            if (val) {
                data = Utils.tryEval($(element).data('value'));
            }
        }

        let config = $.extend(
            true,
            {},
            this.ajaxActionTypes.default.all,
            this.ajaxActionTypes.default[elementFullType] || {}
        );
        config = Utils.getObjectByAttributes(this.tag, element, null, config);

        if (config.form != undefined) {
            const formResult = Ajax.collectForm(element);
            if (!formResult.isValid) return;
            data = $.extend(true, data, {}, formResult.form);
        }

        const toSend: any = {
            data: data,
        };

        if ($(element).attr(this.tag + '-use-spinner') != null) {
            const uiBlock = UiBlock.getUiBlockDescriptor(
                element,
                UiBlock.getDefaultSpinnerBlock(element)
            );
            toSend.uiBlock = uiBlock;
        }

        const func = $(element).attr(this.tag + '-success-action');
        if ($(element).attr(this.tag + '-success-action') != null) {
            toSend.success = (
                data,
                textStatus,
                jqXHR,
                concreteSuccessHandler
            ) => Utils.runFunction(func, element, data);
        }

        if (config.delay) {
            setTimeout(() => {
                Ajax.postJson(url, toSend);
            }, config.delay);
        } else {
            Ajax.postJson(url, toSend);
        }
    }

    private ajaxActionEnterHandler(keyupEvent) {
        if (keyupEvent.which == 13) {
            keyupEvent.preventDefault();

            this.ajaxActionSubmit(keyupEvent.data.ajaxActionElement);
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.AjaxActionBehavior = AjaxActionBehavior;